module.exports = __webpack_public_path__ + "01a7b5ee5c771e1a7ff578abc7772983.jpg";


//////////////////
// WEBPACK FOOTER
// ../images/speakers/anna-henningsen.jpg
// module id = 431
// module chunks = 0